import api from '@common/api';
import { PropertiesModel } from '@common/models/PropertiesModel';
import session from '@common/session';
import create from 'zustand';

interface PropertyDashboardViewModelProps {
  pageState: 'LOADING' | 'ERROR' | 'PROPERTIES' | 'WAITLIST_FORM' | 'WAITLIST_STATUS';
  position?: number | null;
}
interface PropertyDashboardViewModelActions {
  init: () => Promise<void>;
  joinWaitlist: () => Promise<{ error?: string; success: boolean }>;
  setPageState: (pageState: PropertyDashboardViewModelProps['pageState']) => void;
}
export const usePropertiesDashboardViewModel = create<
  PropertyDashboardViewModelProps & PropertyDashboardViewModelActions
>((set) => ({
  init: async () => {
    const investorID = session.get()?.investorId;

    // the backend determines if this investor can see any properties
    // based off criteria such as a pre-existing relationship with us.
    await PropertiesModel.getState().fetchProperties(investorID ?? null);
    set({ pageState: 'PROPERTIES' });
  },
  joinWaitlist: async () => {
    const email = session.get()?.email;
    if (!email) throw new Error('No Email');
    try {
      await api.waitlistAdd({ email });
      return { success: true };
    } catch {
      return { error: 'Unable to add user to waitlist', success: false };
    }
  },
  pageState: 'LOADING',
  setPageState: (pageState) => set({ pageState }),
}));
